import { REPLICATION_SIZE } from '../../../utils/constants';
import {
  auditFields,
  buildReplication,
  getMutationIsActive,
  getMutationNestedValue,
  getMutationStringValue
} from '../utils';

/**
 * Pull builder for collection task confirmation data
 *
 * @param {*} db RxDB database
 */
const pullBuilder = (doc) => {
  const where = doc ? `lastmodifiedAt_Gt: "${doc.lastmodifiedAt}"` : '';

  const query = `{
    listCollectionConfirmations(
      limit: ${REPLICATION_SIZE}
      offset: 0
      ordering: "lastmodifiedAt,ASC"
      ${where}
    ) {
      results {
        id
        icode

        type
        details

        task { id icode }

        ${auditFields}
      }
    }
  }`;

  return { query, variables: {} };
};

/**
 * Push builder for collection task confirmation data
 *
 * @param {*} db RxDB database
 */
const pushBuilder = (doc) => {
  const query = `
    mutation {
      upsertCollectionConfirmation(
        input: {
          ${getMutationStringValue(doc, 'id')}
          ${getMutationStringValue(doc, 'type')}
          ${getMutationStringValue(doc, 'details')}

          ${getMutationNestedValue(doc, 'task')}

          ${getMutationIsActive(doc)}
        }
      ) {
        id
      }
    }
  `;

  return { query, variables: {} };
};

/**
 * Synchronize collection task confirmation data with GraphQL endpoint
 */
export const syncCollectionTaskConfirmation = (...args) => {
  return buildReplication(
    ...args,
    'collectionTaskConfirmation',
    { pullBuilder, pullQuery: 'listCollectionConfirmations' },
    { pushBuilder }
  );
};
